// Featured market photo card with dark overlay
// Used for Phoenix/Eugene hero cards on the available locations page

const CityTile = ({ city, state, image, onClick }) => {
  return (
    <div
      className="city-tile"
      onClick={() => onClick(city, state)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick(city, state);
        }
      }}
    >
      <img
        src={image}
        alt={`${city}, ${state}`}
        className="city-tile__img"
      />
      <div className="city-tile__overlay" />
      <div className="city-tile__content">
        <span className="city-tile__badge">Featured Market</span>
        <h3 className="city-tile__name">{city}, {state}</h3>
      </div>
    </div>
  );
};

export default CityTile;
